import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";
import { VKAtgardRojningTradskiktDTO } from "../../models/skogsvard/skogsvard-models";

export class UpdateSkogsvardTradskiktCommand extends BasicCommand<UpdateSkogsvardTradskiktCommand> {
    readonly atgardGuid: string;
    readonly tradskikt: VKAtgardRojningTradskiktDTO[];
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateSkogsvardTradskiktCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Tradskikt";

    get primaryKey(): IPrimaryKey<UpdateSkogsvardTradskiktCommand> {
        return {
            guid: this.atgardGuid
        };
    }

    constructor(atgardGuid: string, tradskikt: VKAtgardRojningTradskiktDTO[]) {
        super(UpdateSkogsvardTradskiktCommand.$type, UpdateSkogsvardTradskiktCommand.$groupKey, CommandType.Replace);
        this.tradskikt = tradskikt;
        this.atgardGuid = atgardGuid;
    }
}
